import React from 'react'
import { useTranslation } from 'react-i18next'

export default function ImageEmptySection() {
  const { t } = useTranslation()

  return (
    <section class="hero is-default">
      <div class="hero-body ">
        <div class="container">
          <h1 className="title is-5">ยังไม่มีรูป</h1>
          <h2 class="subtitle is-6">
            เพิ่มและแก้ไขรูป ได้ที่ปุ่มมุมขวา
            {/* <div className="tag has-text-info">
              {t('actions.uploadImage.label')}
            </div>{' '}
            <div className="tag has-text-primary">Google Drive</div> */}
          </h2>
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/templates/image-management/ImageEmptySection.js